
import { mapGetters } from 'vuex'
import { footer } from '../../customWhiteLabel'
export default {
  data() {
    return {
      footer,
    }
  },
  computed: {
    ...mapGetters('unidade', ['unidadeInformation']),
  },
  methods: {
    redirecionaSolicitacaoSDC() {
      this.$router.push('/sobre-sdconsulta')
    },
  },
}

